import * as React from 'react';
import { Icon } from '@teamsnap/teamsnap-ui';
import Address from '../../models/address';

export interface Props {
  address: Address;
}

const AddressCard: React.FunctionComponent<Props> = ({ address }) => {
  const line1 = address.line1 ? address.line1.trim() : '';
  const line2 = address.line2 ? address.line2.trim() : '';
  const line1And2 = line1 + line2;
  const formattedLine1And2 = line1And2 ? line1And2 + ', ' : '';
  const city = address.city ? address.city.trim() + ', ' : '';
  const state = address.state ? address.state.trim() + ' ' : '';
  const postal_code = address.postal_code?.trim();

  return (
    <div className="Grid" datatest-id="address">
      <div className="Grid-cell u-sizeFit">
        <Icon name="location" mods="u-spaceRightSm u-colorGrey" />
      </div>
      <div className="Grid-cell u-sizeFill">
        {formattedLine1And2}
        {city}
        {state}
        {postal_code}
      </div>
    </div>
  );
};

export default AddressCard;
